import React, { useContext } from 'react';

import Web3context from '../contexts/Web3context.js'
import abi_1155 from '../contracts/IERC1155Game.json'

function Claim() {
  const web3context = useContext(Web3context)
  let { getWeb3 } = web3context;

  const claim = async () => {
    try {
      const web3 = getWeb3;
      console.log("Network Id is", await web3.eth.net.getId());
      const accounts = await web3.eth.getAccounts();
      const contract_1155 = await new web3.eth.Contract(abi_1155.abi, "0xebe32c46234cA88A373a42Ed3916a7222B3E6BB0");

      // const txnhash = await contract_1155.methods.stake(item.id, ownerAddress, "data")
      //   .send({ from: accounts[0], gasPrice: "1000000000", gas: 35000 });
      // console.log(txnhash);
      // console.log(info);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="Ingredient_wrap">
      <div className="Ingredient_heading">
        <h1>Claim</h1>
      </div>
      <div className="Ingradient_tabs claimContents">
        <p>YOUR UNCLAIMED TOKENS</p>
        <input type="text" className="form-control" />
        <button onClick={claim}>Claim</button>
      </div>
    </div>
  )
}

export default Claim;
